import React from 'react';
import bubbleGif from '../../../images/gif/bubble.gif';

const EventHeader = () => {
    return (
        <div style={{ backgroundImage: `url(${bubbleGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', padding: '20px 20px 20px 20px', borderRadius: 20 }} className="text-center pt-5 pb-5">
            <h4 data-aos="fade-up" data-aos-duration="1000" className="style-font">Be event</h4>
            <h1 data-aos="fade-up" data-aos-duration="2000" className="fw-bolder" style={{ color: '#ff3465' }}>Our Events</h1>
            <p data-aos="fade-up" data-aos-duration="3000">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Amet rem nihil necessitatibus laborum tenetur saepe distinctio suscipit recusandae. Esse, perferendis. Illo esse labore, quaerat itaque perferendis earum repudiandae porro nostrum!</p>
        </div>
    );
};

export default EventHeader;